import * as React from 'react';
import { SVGProps } from 'react';
const SvgDelete = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <mask
      id="SvgDelete_svg__a"
      width={14}
      height={18}
      x={5}
      y={3}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M14.5 3h-5l-1 1H5v2h14V4h-3.5l-1-1ZM16 9v10H8V9h8ZM6 7h12v12c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V7Z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#SvgDelete_svg__a)">
      <path fill="#E8697D" d="M0 0h24v24H0z" />
    </g>
  </svg>
);
export default SvgDelete;
